import {Formik} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {ApplicationRecordFormProps} from '../types';
import {buildInitialValues, FormValues} from './buildInitialValues';
import {stage} from "../../../config/stage";


export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: ApplicationRecordFormProps) => {

    // FNP-1498: the payload is the form values, unchanged.
    //
    // This used to strip a form-only `provisionAutomatically` flag and, when
    // it was set, force applicationStatus to CREATING — so filling in a
    // checkbox silently started building two repos, two pipelines, a bucket,
    // a distribution and DNS. Provisioning is its own act now, with its own
    // form, and creating a record creates a record.
    const onSubmit = (values: FormValues) => {
        handleSubmit(values);
    };

    const initialValues = buildInitialValues(record);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
